
import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import { loadStart, loadFinish, loadError } from 'common/redux/root'
import {
  AGENT_DISTANCE,
  AGENT_DISTANCE_DENSE
} from 'common/constants'

const RESET = 'settings/RESET'
const LOAD = 'settings/LOAD'
const MULTISELECT = 'settings/MULTISELECT'

const load = createAction(LOAD)
const reset = createAction(RESET)
const multiselect = createAction(MULTISELECT)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
    dispatch(load(response))
    dispatch(loadFinish())
    return Promise.resolve(response)
}

export const fetchSettings = () => {
  return dispatch => {
    dispatch(loadStart())
    return client.post('fetch_settings')
    .then(response => {
      const distanceValues = response.is_dense_market ? AGENT_DISTANCE_DENSE : AGENT_DISTANCE
      dispatch(reset())
      dispatch(load(response))
      dispatch(load({distanceValues: distanceValues}))
      dispatch(loadFinish())
      return Promise.resolve(response)
    })
    .catch(dispatch(defaultErrorHandler))
  }
}

export const fetchAgentMvipSettings = () => {
  return dispatch => {
    dispatch(loadStart())
    return client.post('agent_mvip_settings')
    .then(response => {
      dispatch(load(response))
      dispatch(loadFinish())
      return Promise.resolve(response)
    })
    .catch(dispatch(defaultErrorHandler))
  }
}

export function updatePrice(key, enabled) {
  return dispatch => {
    dispatch(multiselect({multiselect:'price_categories', key, enabled}))
  }
}

export function updateClientCategories(key, enabled) {
  return dispatch => {
    dispatch(multiselect({multiselect:'client_categories', key, enabled}))
  }
}

export function saveClientCategories(client_categories) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_lead_settings', {
      data: {
        client_categories
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function updatePropertyCategories(key, enabled) {
  return dispatch => {
    dispatch(multiselect({multiselect:'property_categories', key, enabled}))
  }
}

export function savePropertyCategories(property_categories) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_lead_settings', {
      data: {
        property_categories
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function savePriceCategories(price_categories) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_lead_settings', {
      data: {
        price_categories
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}


export function saveLocation(base_zip, agent_distance_category, license_states=null) {
  return dispatch => {
    dispatch(loadStart())
    let payload = {
      base_zip,
      agent_distance_category,
    }
    if (license_states !== null) {
      payload['license_states'] = license_states
    }
    return client.post('save_location', {
      data: payload,
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function updateZipcode(base_zip) {
  return dispatch => {
    dispatch(load({
        isDirty: true,
        isValidating: true,
        base_zip
    }))
  }
}

export function validateZipcode(zipcode, distance_category, is_filter=false) {
  return dispatch => {
    return client.post('validate_zipcode', {
      data: {
        zipcode,
        distance_category,
        is_filter,
      }
    })
    .then(response => {
      dispatch(load(response))
      dispatch(load({ isValidating:false }))
      if(response.found && response.exists) {
        dispatch(load({ mapUpdateKey: new Date() }))
      }
      return Promise.resolve(response)
    })
    .catch(dispatch(defaultErrorHandler))
  }
}

export function fetchUnblockedZipcodes() {
  return dispatch => {
    return client.post('fetch_unblocked_zipcodes', {
      data: {}
    })
    .then(dispatch(defaultLoadHandler))
    .catch (dispatch(defaultErrorHandler))
  }
}

export function bulkAddZipFilter(zipcodes) {
  return dispatch => {
    return client.post('bulk_add_zip_filter', {
      data: {
        zipcodes
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function addZipFilter(zipcode) {
  return dispatch => {
    return client.post('add_zip_filter', {
      data: {
        zipcode
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function removeZipFilter(zipcode) {
  return dispatch => {
    return client.post('remove_zip_filter', {
      data: {
        zipcode
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function updateLocationDistance(agent_distance_category) {
  return dispatch => {
    dispatch(load({agent_distance_category}))
  }
}

export function updateSnoozeCategory(snooze_category) {
  return dispatch => {
    dispatch(load({
        snooze_category
    }))
  }
}

export function updateNotificationMode(notification_mode) {
  return dispatch => {
    dispatch(load({
        notification_mode
    }))
  }
}

export function updateDoNotDisturb(payload, makeDirty=true) {
  return dispatch => {
    if (makeDirty) {
      payload['do_not_disturb_dirty'] = true
    }
    dispatch(load(payload))
  }
}

export function updateDistanceValues(distanceValues) {
  return dispatch => {
    dispatch(load({
      distanceValues
    }))
  }
}

export function updateAvatar(image_path) {
  return dispatch => {
    dispatch(load({
      image_path
    }))
  }
}

export function updateSocialProfiles(social_profiles) {
  return dispatch => {
    dispatch(load({
      social_profiles
    }))
  }
}

export function saveNotificationMode(notification_mode) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_notification_mode', {
      data: {
        notification_mode
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function saveSnoozeCategory(snooze_category) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_snooze', {
      data: {
        snooze_category
      }
    })
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function removeSnoozeCategory() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('remove_agent_snooze')
    .then(dispatch(defaultLoadHandler))
    .catch(dispatch(defaultErrorHandler))
  }
}

export function saveDoNotDisturb(do_not_disturb_enabled, do_not_disturb_start, do_not_disturb_end) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_agent_do_not_disturb', {
      data: {
        do_not_disturb_enabled,
        do_not_disturb_start,
        do_not_disturb_end
      }
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function saveAvatar(image_path) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('save_avatar', {
      data: {
        image_path
      }
    })
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function removeAvatar() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('remove_avatar')
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function createSocialProfile() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('create_social_profile')
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function download_agent_agreement() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('download_agent_agreement')
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function download_w9() {
  return dispatch => {
    dispatch(loadStart())
    return client.post('download_w9')
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

export function setAgentOnboardDate() {
  return dispatch => {
    return client.post('set_agent_onboard_call_date')
      .catch(dispatch(defaultErrorHandler))
  }
}

const initialState = {
}

export default handleActions({
    [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
    [RESET]: (state, { payload }) => ({ ...initialState }),
    [MULTISELECT]: (state, { payload }) => {
      const multiselect =  { ...state[payload.multiselect] }
      if (payload.enabled) {
        multiselect[payload.key] = true
      } else {
        delete multiselect[payload.key]
      }

      return {...state, [payload.multiselect]: multiselect}
    },
}, initialState)
